"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiCard: {
    root: {
      backgroundColor: "white"
    }
  },
  MuiCardActions: {
    root: {
      justifyContent: "flex-end",
      padding: "".concat(_theme.spacing[6], " ").concat(_theme.spacing[6])
    },
    spacing: {
      "& > :not(:first-child)": {
        marginLeft: _theme.spacing[3]
      }
    }
  },
  MuiCardContent: {
    root: {
      "&:last-child": {
        paddingBottom: _theme.spacing[6]
      },
      fontSize: "0.875rem",
      padding: "".concat(_theme.spacing[3], " ").concat(_theme.spacing[4])
    }
  },
  MuiCardHeader: {
    action: {
      marginRight: 0,
      marginTop: 0
    },
    root: {
      borderBottom: "1px solid",
      borderBottomColor: _theme.palette.brand.grey.pebble,
      padding: "0.75rem ".concat(_theme.spacing[4])
    }
  }
};
exports.default = _default;